var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 1C18 1.55228 17.5523 2 17 2L1 2C0.447716 2 0 1.55229 0 1C0 0.447717 0.447716 0 1 0H17C17.5523 0 18 0.447715 18 1ZM15 6.00024C15 6.55253 14.5523 7.00024 14 7.00024L4 7.00025C3.44771 7.00025 3 6.55253 3 6.00025C3 5.44796 3.44771 5.00025 4 5.00025L14 5.00024C14.5523 5.00024 15 5.44796 15 6.00024ZM11 12C11.5523 12 12 11.5523 12 11C12 10.4477 11.5523 10 11 10H7C6.44772 10 6 10.4477 6 11C6 11.5523 6.44772 12 7 12H11Z",
    fill: "#0071E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.54ab3136bd7d802e9bab0eeeaff5dad7.svg";
export { ForwardRef as ReactComponent };